import { render, staticRenderFns } from "./AddTemporaryCashAllocation.vue?vue&type=template&id=0b560e3c&"
import script from "./AddTemporaryCashAllocation.vue?vue&type=script&lang=js&"
export * from "./AddTemporaryCashAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports